import React, { useRef, useState } from "react";
import "./signin.css";
import { ReactComponent as MainLogo } from "../../assets/signin/Logo.svg";
import axiosInstance from "../../helpers/axiosInstance";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../shared/loading/Loading";
import GoogleSignInButton from "./GoogleSignInButton";

function Signin(props) {
  const [loading, setLoading] = useState(false);
  const emailRef = useRef("");
  const passwordRef = useRef("");
  const navigate = useNavigate();
  // const location = useLocation();
  const from = "/organisations";

  // Either way of signing in ends here, with the same session.
  const signedIn = (data) => {
    // Store in localStorage - AuthProvider will read these when mounted
    localStorage.setItem("accessToken", data.accessToken);
    localStorage.setItem("refreshToken", data.refreshToken);
    localStorage.setItem("user", JSON.stringify(data.userModel));
    // Organisation selection is deliberately required after every login.
    localStorage.removeItem("organisation");
    // Navigate to protected route - triggers AuthProvider to mount and read localStorage
    navigate(from, { replace: true });
  };

  const failed = (error, fallback) => {
    const message = error?.response?.data?.message || error?.response?.data?.error || error?.message || fallback;
    toast(message);
  };

  // Google has said who this is; the server decides which member that is.
  const handleGoogle = (credential) => {
    setLoading(true);
    axiosInstance
      .post("/api/user/google", { idToken: credential, fcm_token: props.fcmToken })
      .then((response) => {
        setLoading(false);
        signedIn(response.data);
      })
      .catch((error) => {
        setLoading(false);
        failed(error, "Google sign-in did not work. Try again, or sign in with your password.");
      });
  };

  function handleSubmit(e) {
    setLoading(true);
    const email = emailRef.current.value.toString().toLowerCase();
    const Logindata = {
      email: email,
      password: passwordRef.current.value,
      fcm_token: props.fcmToken,
    };
    e.preventDefault();
    axiosInstance
      .post("/api/user/signin", Logindata)
      .then((response) => {
        setLoading(false);
        signedIn(response.data);
      })
      .catch((error) => {
        setLoading(false);
        failed(error, "Unable to login");
      });
  }
  return (
    <div className="signin-container">
      <MainLogo className="signin-main-logo" />
      <form className="signin-login-wrapper" onSubmit={handleSubmit}>
        <label>Login</label>
        <div className="signin-login-formsection">
          <input
            autoFocus
            tabIndex="1"
            type="text"
            ref={emailRef}
            placeholder="Enter your registered email ID"
            autoComplete="off"
            name="email"
          />
          <input
            tabIndex="2"
            type="password"
            ref={passwordRef}
            placeholder="Password"
            autoComplete="off"
            name="password"
          />
        </div>
        <div className="signin-forgotpassword-right">
          <label
            onClick={() => {
              navigate("/forgotpassword", { replace: true });
            }}
          >
            Forgot Password
          </label>
        </div>
        <button className="signin-login-btn" disabled={loading}>
          {loading ? <Loading /> : "Sign In"}
        </button>
        <GoogleSignInButton onCredential={handleGoogle} onError={(message) => toast(message)} disabled={loading} />
      </form>
    </div>
  );
}

export default Signin;
